import { callApi } from '@local_modules/generic/fetch.js'
import { showAccountDetails } from '../show.js'

export async function updateName (params) {
  const { browserAppAccount } = params
  console.log('browserAppAccount', browserAppAccount)

  const newNameElement = document.getElementById('renamingAccountNewName')
  console.log('newNameElement', newNameElement)
  console.log('newNameElement', newNameElement.value)

  const newName = newNameElement.value

  const data = {
    name: newName
  }

  const apiEndpoint = '/api/app-account/:appAccountId/update'

  await callApi(apiEndpoint, {
    appAccountId: browserAppAccount.data?.appAccountId
  }, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
  await refreshAccountDetails(browserAppAccount.data?.appAccountId, browserAppAccount)
}

async function refreshAccountDetails (appAccountId, browserAppAccount) {
  await browserAppAccount.load({ appAccountId })
  showAccountDetails({ browserAppAccount })
}
